<template>
  <div class="type-home">
    <p class="title">{{ typeName }}</p>

    <div class="card-grid">
      <div class="line" />

      <EventCard class="card" v-for="evEvent in evEvents" :key="evEvent.id" :evEvent="evEvent" />
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, computed } from 'vue';

import EventCard from '@/components/event/EventCard.vue';
import EventService from '@/services/event';
import $conversion from '@/utils/conversion';

const props = defineProps({
  typecode: {
    type: String,
    default: null,
  },
});

const evEvents = ref([]);

onBeforeMount(async () => {
  // Get all published events from server
  const eventResults = await EventService.getEvents(props.typecode.toUpperCase());

  // Organize events according to their types
  evEvents.value = eventResults.records.map((evEvent) => $conversion.eventToUI(evEvent));
});

const typeName = computed(() => {
  return evEvents.value[0] ? evEvents.value[0].type_text : '';
});
</script>

<style scoped>
.type-home {
  min-height: calc(100% - 184px);
  padding-top: 58px;
  padding-bottom: 126px;

  background: linear-gradient(180deg, #002936 0%, #1f184b 100%);
}

@media (min-width: 1440px) {
  .type-home {
    font-size: 18px;
  }
}

.title {
  font-family: Helvetica;
  font-size: 1.8em;
  color: #b5b5b5;
  text-align: center;
}

.line {
  width: 100%;
  height: 1px;
  border-top: 1px solid #ffffff;
}

.card-grid {
  width: 85%;
  max-width: 1666px;
  margin: 0 auto;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.card-grid :deep(.event-card) {
  width: 100%;
}

@media only screen and (min-width: 950px) {
  .card-grid :deep(.event-card) {
    width: 48%;
  }
}

@media only screen and (min-width: 1600px) {
  .card-grid :deep(.event-card) {
    width: 32%;
  }
}

.card {
  margin-top: 38px;
}
</style>
